<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <NeList ref='neList' :neArr='netype' :select='neClick'></NeList>
    </template>
    <template v-slot:right_view>
      <SupiTableMenu @methodEnum='methodEnum'></SupiTableMenu>
      <SupiTable ref="supiTable"></SupiTable>
    </template>
  </BasicLayout>
</template>

<script>
import SupiTable from '../../../../components/subscriberconfig/udmSubscriber/supi/SupiTable';
import SupiTableMenu from '../../../../components/subscriberconfig/udmSubscriber/supi/SupiTableMenu';
import BasicLayout from '../../../../layouts/BasicLayout';
import NeList from '../../../../components/common/NeList';

export default {
  name: 'SupiMainPage',
  components: {
    NeList,
    SupiTable,
    SupiTableMenu,
    BasicLayout,
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t("LteUser.nelist"),
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: this.$t("Supi.crumb"),
      },
      netype: [36],
    };
  },
  methods: {
    methodEnum(opcode, params) {
      switch (opcode) {
        case 'add':
          this.$refs.supiTable.openAddUserPage();
          break;
        case 'addBatch':
          this.$refs.supiTable.openAddBatchUserPage();
          break;
        case 'mod':
          this.$refs.supiTable.openModUserPage();
          break;
        case 'del':
          this.$refs.supiTable.delUsers();
          break;
        case 'delRange':
          this.$refs.supiTable.openDelRangePage();
          break;
        case 'qry':
          this.$refs.supiTable.qryUsers(0, true);
          break;
        case 'chg':
          this.$refs.supiTable.setfilter(params);
          break;
        case 'src':
          this.$refs.supiTable.qryUsers(2, true);
          break;
        default:
      }
    },
    neClick(ne) {
      this.$refs.supiTable.getGridData(this.$refs.neList.getNe());
    }
  }
};
</script>

<style scoped>

</style>
